import { render, staticRenderFns } from "./errorpage.vue?vue&type=template&id=cd1ff10e"
import script from "./errorpage.vue?vue&type=script&lang=js"
export * from "./errorpage.vue?vue&type=script&lang=js"
import style0 from "./errorpage.vue?vue&type=style&index=0&id=cd1ff10e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports